import { render, staticRenderFns } from "./LightEffect.vue?vue&type=template&id=0f1290c0"
import script from "./LightEffect.vue?vue&type=script&lang=js"
export * from "./LightEffect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports